import { VideoInputAntennaIcon } from './VideoInputAntennaIcon';

/**
 * author: Google
 * id D7B7AA15-66CB-4AA5-AD75-E96B78B89AB9
 * name video-input-antenna
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/video-input-antenna.svg
 * tags
 * - Video / Movie 
 */
export const SettingsInputAntennaIcon = VideoInputAntennaIcon;
export default SettingsInputAntennaIcon